/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback, useEffect } from 'react';
import { Drawer, Card, Form, Row, Col, Select, Checkbox } from 'antd';
import ActionButtonsBar from '@ui/ActionButtonsBar'
import Loading from '../../../../../../components/Loading'
import { getOTACodes } from '../../../../../../services/common'
import Input from '../../../../../ui/Input';
import { LocalPersistence } from "../../../../../../factories";
import { updateMeetingRoomCapacity, addMeetingRoomCapacity, deleteMeetingRoomCapacity } from '../../../../../../services/meetingrooms'

interface editAmenityProps {
  onClose: () => void;
  visible: boolean;
  setOperation: (a: string) => void;
  setCurrentRow: (a: []) => void;
  setDefKey: (a: string) => void;
  setSingleAmenity: (a: any) => void;
  setDataSource: (a: any) => void;
  currentRow: [] | any;
  name: string;
  data: { roomid: number, roomlangid: number, capacity: [] };
  meetingroomsid: number;
  setCurrentLine: (a: any) => void;
}

const CapacityModal = (props: editAmenityProps) => {
  const [form] = Form.useForm()
  const [disableFlag, setDisableFlag] = useState<boolean>(false)
  const [mrfData, setMrfData] = useState([])
  const [ready, setReady] = useState(false);
  const { Option } = Select;

  const getMRFdata = useCallback(async () => {
    let res = await getOTACodes('MRF', '')
    let rest = res?.otacodes || []
    setMrfData(rest)
  }, [])

  const saveCapacity = async () => {
    setDisableFlag(true)
    const get_session = new LocalPersistence('session')
    const session: any = await get_session.getSessionPersistence()
    form.validateFields()
      .then(async (value: any) => {
      let capacityArr: any = []

      if (Object.keys(props.currentRow).length > 0) {
        capacityArr = props.data.capacity
        props.data.capacity.map((item: any, index: number) => {
          if (item.capacityid === props.currentRow.capacityid) {
            return capacityArr[index] = {
              capacityid: props.currentRow.capacityid,
              ...value
            }
          }
          return false
        })
      } else {
        capacityArr.push(value)
      }

      let bodyQuery = {
          "supplier": session.supplier,
          "propertyId": session.propertyId,
          "property": {
              "meetingrooms": {
                  "meetingroomsid": props.meetingroomsid,
                  "meetingroom": [
                      {
                          "roomid": props.data.roomid,
                          "roomlangid": props.data.roomlangid,
                          "capacity": capacityArr
                      }
                  ]
              }
          }
      }

      if (Object.keys(props.currentRow).length > 0) {
        updateMeetingRoomCapacity(bodyQuery)
          .then(res => {
            const [mtroom] = res.property.meetingrooms.meetingroom.filter(({ roomid } : { roomid: number }) => roomid === props.data.roomid)
            props.setDataSource(mtroom.capacity)
            props.setCurrentLine(mtroom)
            setDisableFlag(false)
            props.onClose()
        })
        .catch(() => setDisableFlag(false))
      } else {
        addMeetingRoomCapacity(bodyQuery)
          .then(res => {
            const [mtroom] = res.property.meetingrooms.meetingroom.filter(({ roomid } : { roomid: number }) => roomid === props.data.roomid)
            props.setDataSource(mtroom.capacity)
            props.setCurrentLine(mtroom)
            setDisableFlag(false)
            props.onClose()
          })
          .catch(() => setDisableFlag(false))
      }
    })
  }

  const deleteCapacity = async () => {
    setDisableFlag(true)
    const get_session = new LocalPersistence('session')
    const session: any = await get_session.getSessionPersistence()
    let bodyQuery = {
      "supplier": session.supplier,
      "propertyId": session.propertyId,
      "property": {
          "meetingrooms": {
              "meetingroomsid": props.meetingroomsid,
              "meetingroom": [
                  {
                      "roomid": props.data.roomid,
                      "roomlangid": props.data.roomlangid,
                      "capacity": [{ "capacityid":props.currentRow.capacityid }]
                  }
              ]
          }
      }
    }
    deleteMeetingRoomCapacity(bodyQuery)
    .then(res => {
      const [mtroom] = res.property.meetingrooms.meetingroom.filter(({ roomid } : { roomid: number }) => roomid === props.data.roomid)
      props.setDataSource(mtroom.capacity)
      props.setCurrentLine(mtroom)
      setDisableFlag(false)
      props.onClose()
    })
    .catch(() => setDisableFlag(false))
  }

  useEffect(() => {
    if (props.visible) {
      getMRFdata()
      setTimeout(() => setReady(true), 300)
      setDisableFlag(false)
    } else {
      form.resetFields();
      setReady(false);
    }
  }, [props.visible])

  return (
    <>
       <Drawer
       title={`${props.name} - Capacity`} 
       placement="right" 
       onClose={props.onClose} 
       visible={props.visible} 
       width={976} 
       afterVisibleChange={() => {
         form.setFieldsValue({ 
          name: props.currentRow?.name,
          format: props.currentRow?.format,
          maxcapacity: props.currentRow?.maxcapacity
          }); 
       }}>
        { ready && <Card style={{ marginTop: -15, marginBottom: 65 }}> 
          <Form
            layout='vertical'
            form={form}
            name='basic'
            >
            <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                label='Capacity Name'
                name="name"
                rules={[
                  {
                    max: 128,
                    message:
                      'You have reached the max character length of 128',
                  },
                ]}>
                <Input maxLength={128}   />
              </Form.Item>
            </Col>
            <Col span={13}>
              <Form.Item
                label='Seating Format'
                name='format'>
                <Select allowClear showSearch>
                  {mrfData.map((item: any, i) => {
                    return (
                      <Option
                        key={item.codeName}
                        value={item.codeName}>
                        {item.codeName}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={13}>
              <Form.Item
                label='Maximum Capacity'
                name='maxcapacity'
                rules={[
                  {
                    pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
            </Row>
            <br />
          </Form>
          { disableFlag && <Loading type="large" /> }
          <ActionButtonsBar
            onCancel={props.onClose}
            onSave={() => saveCapacity()}
            disabledSave={disableFlag}
            show={true}
            onDelete={Object.keys(props.currentRow).length > 0 ? () => deleteCapacity() : false}
          />
        </Card>}
        {!ready && <Loading type="medium" />}
      </Drawer>
    </>
  )
}

export default CapacityModal
